import { render, staticRenderFns } from "./Problems.vue?vue&type=template&id=28e3b67e&scoped=true"
import script from "./Problems.vue?vue&type=script&lang=js"
export * from "./Problems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e3b67e",
  null
  
)

export default component.exports